<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="fabJobId">Job</label>
                    <wj-combo-box
                        id="fabJobId"
                        name="fabJobId"
                        [(ngModel)]="target.fabJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        [isDisabled]="!canEdit"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="scope">Scope</label>
                    <wj-combo-box
                        id="scope"
                        name="scope"
                        [(ngModel)]="target.scope"
                        [itemsSource]="scopeOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        [isDisabled]="!canEdit"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="markCode">DWG #</label>
                    <input id="markCode" name="markCode" type="text" class="form-control" [(ngModel)]="target.markCode" />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="quantity">Quantity</label>
                    <input
                        id="quantity"
                        name="quantity"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.quantity"
                        required
                        min="1"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="isStock">Is Stock</label>
                    <wj-combo-box
                        id="isStock"
                        name="isStock"
                        [(ngModel)]="target.isStock"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" name="name" type="text" class="form-control" [(ngModel)]="target.name" required />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="priority">Priority</label>
                    <wj-combo-box
                        id="priority"
                        name="priority"
                        [(ngModel)]="target.priority"
                        [itemsSource]="priorityOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isDisabled]="!canEdit"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea id="description" name="description" class="form-control" rows="2" [(ngModel)]="target.description"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="requiredOnSiteDate">Required On Site</label>
                    <wj-input-date
                        id="requiredOnSiteDate"
                        name="requiredOnSiteDate"
                        [(ngModel)]="target.requiredOnSiteDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="isRework">Rework / Remake</label>
                    <wj-combo-box
                        id="isRework"
                        name="isRework"
                        [(ngModel)]="target.isRework"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        @if (stepDates.length) {
            <hr />
            <h6>Process Step Dates</h6>
            <div class="row">
                @for (sd of stepDates; track sd.stepId) {
                    <div class="col-md-4 mb-2">
                        <div class="form-group">
                            <div class="d-flex justify-content-between align-items-center">
                                <label class="mb-0" [for]="'step_' + sd.stepId">
                                    <span
                                        class="d-inline-block me-1"
                                        style="width: 0.75rem; height: 0.75rem; border-radius: 2px; vertical-align: middle"
                                        [style.backgroundColor]="sd.colorHex"
                                    ></span>
                                    {{ sd.name }}
                                </label>
                                <div class="form-check mb-0">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        [id]="'na_' + sd.stepId"
                                        [name]="'na_' + sd.stepId"
                                        [(ngModel)]="sd.notApplicable"
                                        (ngModelChange)="onNotApplicableChanged(sd)"
                                        [disabled]="!canEdit"
                                    />
                                    <label class="form-check-label" [for]="'na_' + sd.stepId">NA</label>
                                </div>
                            </div>
                            <wj-input-date
                                [id]="'step_' + sd.stepId"
                                [name]="'step_' + sd.stepId"
                                [(ngModel)]="sd.actualDate"
                                (ngModelChange)="onStepDateChanged(sd)"
                                [isRequired]="false"
                                [isDisabled]="sd.notApplicable || !canEdit"
                            ></wj-input-date>
                        </div>
                    </div>
                }
            </div>
        }

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <hr />
            <h6>Drawings / Photos</h6>
            <div class="row">
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-md-4 mb-2">
                        @if (canEdit) {
                            <div class="close-x" (click)="removeExistingDrawing(url)">
                                <fa-icon [icon]="faX"></fa-icon>
                            </div>
                        }
                        @if (isImageUrl(url)) {
                            <img style="max-width: 250px; cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openDrawing(url)" alt="" />
                        } @else if (isPdf(url)) {
                            <img class="attachment-pdf-thumb" style="cursor: pointer" src="./Resources/pdfImage.png" (click)="openDrawing(url)" alt="" />
                        } @else {
                            <button type="button" class="btn btn-link p-0" (click)="openDrawing(url)">{{ displayFileName(i) }}</button>
                        }
                        @if (isImageUrl(url) || isPdf(url)) {
                            <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                        }
                    </div>
                }
            </div>
        }
        @if (drawings.length > 0) {
            <div class="row">
                <label>Drawings / Photos To Upload</label>
                @for (file of drawings; track file) {
                    <div class="col-sm-6 col-md-4 mb-2">
                        <div class="close-x" (click)="removeDrawing(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        @if (pendingPreviewUrl(file); as src) {
                            <img style="max-width: 250px" [src]="src" alt="" />
                        } @else {
                            <span>{{ file.name }}</span>
                        }
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            [attr.aria-valuenow]="progress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        @if (canEdit) {
            <div style="margin-right: auto">
                <button type="button" class="btn btn-success me-2" (click)="drawingInput.click()" [disabled]="isSaving">Drawing</button>
                <input style="display: none" type="file" (change)="onDrawingChanged($event)" #drawingInput multiple />
                <button type="button" class="btn btn-success" (click)="photoInput.click()" [disabled]="isSaving">Photo</button>
                <input
                    style="display: none"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    (change)="onDrawingChanged($event)"
                    #photoInput
                />
            </div>
        }
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
